import { Component, inject } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { AffordabilityService } from 'apps/lghf/src/app/services';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ff-work-income-repeat',
  styleUrls: ['work-income-repeat.component.scss'],
  templateUrl: 'work-income-repeat.component.html',
  imports: [NgbTooltip, FormlyModule],
})
export class FormlyWorkIncomeRepeatComponent extends FieldArrayType {
  private readonly affordabilityService = inject(AffordabilityService);

  public confirmView: number = null;

  public addNewField() {
    this.affordabilityService.addAdditionalBenefitField(this.applicantIndex, this.fieldName.toString());
  }

  public deleteField(field) {
    this.affordabilityService.deleteAdditionalBenefitField(this.applicantIndex, this.fieldName.toString(), field.index);
    this.confirmView = null;
  }

  public canDeleteField(field) {
    const fieldLength = this.affordabilityService.model.incomeAndExpenditure
      .applicants[this.applicantIndex][this.fieldName.toString()].length;
    return fieldLength > 1 && field.index > 0;
  }

  public toggleConfirmView(index: number) {
    this.confirmView = index;
  }

  public get applicantIndex() {
    return this.field.parent['index'];
  }

  public get fieldName() {
    return this.field['key'];
  }
}
